import { useContext } from 'react'
import { CandidateSqlSearchContext } from 'recruiter/contexts/CandidateSqlSearchContext'

/**
 * Provides access to values in the SQL-based candidate search context.
 */
export const useCandidateSqlSearch = () => {
    const context = useContext(CandidateSqlSearchContext)

    if (!context) {
        throw new Error(
            'useCandidateSqlSearch must be used within CandidateSqlSearchProvider'
        )
    }

    return context
}
